import React, { useContext, createContext, useState, useEffect } from "react";

export const NewOfferMobileContext = createContext();
export const useNewOfferMobile = () => useContext(NewOfferMobileContext);
export const NewOfferMobileProvider = ({ children }) => {
	const [stepError, setStepError] = useState(false);
	const values = {
		stepError,
		setStepError
	};
	return <NewOfferMobileContext.Provider value={values}>{children}</NewOfferMobileContext.Provider>;
};
